export const initialValues = {
    name: '',
    description: '',
    image: '',
    icon: '',
    drops: []
};

export const pictureAttributeNames = [
    "image",
    "icon"
];
